import { truckApi } from "./truck.api";

export const {
  useGetIsTruckQuery,
  useLazyGetIsTruckQuery,
  useGetTruckQuery,
  useLazyGetTruckQuery,
  useGetHasTruckQuery,
  useLazyGetHasTruckQuery,
  useSaveNewTruckMutation,
  useSaveDeleteTruckMutation,
  useSaveEditTruckMutation,
  useSaveRebindTruckMutation,
  useSaveUnbindTruckMutation,
  useGetTruckByDriverQuery,
  useLazyGetTruckByDriverQuery
} = truckApi;
